import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const LANGS = ["En", "Ar", "Ku"];

const VoyahDreamExpEditor = () => {
  const [form, setForm] = useState({
    titleEn: "",
    titleAr: "",
    titleKu: "",
    descriptionEn: "",
    descriptionAr: "",
    descriptionKu: "",
    videoUrl: ""
  });

  const [loading, setLoading] = useState(true);

  // ================================
  // FETCH 3 LANGUAGES
  // ================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VoyahDreamExpSection?lang=en`),
          axios.get(`${API_BASE}/api/VoyahDreamExpSection?lang=ar`),
          axios.get(`${API_BASE}/api/VoyahDreamExpSection?lang=ku`),
        ]);

        setForm({
          titleEn: en.data.title,
          descriptionEn: en.data.description,
          videoUrl: en.data.videoUrl,

          titleAr: ar.data.title,
          descriptionAr: ar.data.description,

          titleKu: ku.data.title,
          descriptionKu: ku.data.description
        });

        setLoading(false);
      } catch (err) {
        console.error("Failed to load DreamExp section:", err);
      }
    };

    load();
  }, []);

  // FORM HANDLER
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ================================
  // SAVE (FIXED URL)
  // ================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      // FIXED — correct endpoint
      await axios.put(`${API_BASE}/api/VoyahDreamExpSection`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Saved successfully!");
    } catch (err) {
      console.error(err);
      alert("Failed to save.");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">
        VOYAH DREAM — Experience Section Editor
      </h2>

      <p className="alert alert-info">
        You must fill ALL languages (EN, AR, KU) or the website will not render correctly.
      </p>

      {/* LANGUAGE GROUPS */}
      <div className="row">
        {LANGS.map((lang) => (
          <div key={lang} className="col-lg-4 col-md-6 mb-4">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="text-primary mb-3">{lang} Version</h5>

                <label className="form-label">Title</label>
                <input
                  className="form-control mb-3"
                  name={`title${lang}`}
                  value={form[`title${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Description</label>
                <textarea
                  className="form-control mb-3"
                  name={`description${lang}`}
                  rows="4"
                  value={form[`description${lang}`]}
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* VIDEO URL */}
      <div className="mb-4">
        <label className="form-label fw-bold">YouTube Video URL</label>
        <input
          className="form-control"
          name="videoUrl"
          value={form.videoUrl}
          onChange={handleChange}
        />
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-5">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default VoyahDreamExpEditor;
